import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-110" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-111" data-mp="1dxjhbbtfivbz">
        <SectionHeading id="modules-title" data-id="element-112" data-mp="1dunill9rc2mh">The {totalVolumes} <span className="text-fiber" data-id="element-113" data-mp="2bj7fo29g3nq5">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-114" data-mp="26kmdvyejovzl">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-line bg-navy-900 p-6 shadow-lg shadow-black/30" data-id="element-115" data-mp="21o5nexjvi5jc" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-116" data-mp="1ntk1a9xga7n8">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-fiber/10 text-fiber" data-id="element-117" data-mp="18xuck40vrget">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-118" data-mp="1duuga8a9c72r" />
                  </span>
                  <p className="text-sm font-semibold text-gold" data-id="element-119" data-mp="103pnnq5b4f1x">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-semibold leading-tight text-white" data-id="element-120" data-mp="14x0onanfu1lx">{module.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-silver" data-id="element-121" data-mp="q84jblcrn2p0">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}